module.exports = __webpack_public_path__ + "static/media/accordion_arrow.3677a5f2.svg";